// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__DgTNS","isActive":"Avatar_isActive__7w7or","initials":"Avatar_initials__Izs75","link":"Avatar_link__OdWQB"};